import { IFont } from '../FontPicker/FontPicker.types.shared';
import { IGroupedComboBoxItem } from 'grouped-combobox-core';
import { IInternalFont } from './internalFont';
import { assert } from './assert';
import { isFontVariant, isMruEntry } from './fontUtils';

export function isFontPinned(f: IFont): boolean {
    if (isMruEntry(f)) {
        return false;
    }
    const internalFont: IInternalFont = f;
    return internalFont.$isPinned ?? false;
}

export function getFontAndPinnedState(groupBoxItem: IGroupedComboBoxItem): [IFont, boolean] {
    assert(groupBoxItem.data);
    const internalFont = groupBoxItem.data as IInternalFont;
    const { $isPinned } = internalFont;
    return [internalFont, $isPinned ?? false];
}

export function setFontPinnedState(groupBoxItem: IGroupedComboBoxItem, isPinned: boolean): void {
    assert(groupBoxItem.data);
    const internalFont = groupBoxItem.data as IInternalFont;
    if (isPinned) {
        internalFont.$isPinned = true;
    } else {
        delete internalFont.$isPinned;
    }
}

/**
 * Check if a font can be pinned
 * @param font - The font to check if it can be pinned
 * @returns true if the specified font can be pinned.
 */
export function canPinFont(font: IFont, isSubscriber: boolean): boolean {
    if (!isSubscriber) {
        return false;
    }

    // we don't allow pinning from Mru.
    if (isMruEntry(font)) {
        return false;
    }

    if (isFontVariant(font)) {
        return true;
    }

    // font family
    return font.fontType !== 'organization';
}
